import React from "react";
import { HomePhoneShippingDetails } from "../../../../../types/homePhone";
import ORDER_REVIEW from "../constants";

interface ShippingAddressProps {
  shippingDetails: HomePhoneShippingDetails;
}

const ShippingAddress: React.FC<ShippingAddressProps> = ({ shippingDetails }) => (
  <div className="or-shipping-grid">
    <div className="or-shipping-col">
      <span className="or-col-label">{ORDER_REVIEW.LABELS.DESTINATION}</span>
      <strong>{shippingDetails.fullName}</strong>
      <span>{shippingDetails.addressLine1}</span>
      {shippingDetails.addressLine2 && (
        <span>{shippingDetails.addressLine2}</span>
      )}
      <span>
        {shippingDetails.city}, {shippingDetails.state}{" "}
        {shippingDetails.postalCode}
      </span>
      <span>{shippingDetails.country}</span>
    </div>

    <div className="or-shipping-col">
      <span className="or-col-label">{ORDER_REVIEW.LABELS.CONTACT}</span>
      <strong>{ORDER_REVIEW.LABELS.PHONE_NUMBER}</strong>
      <span>{shippingDetails.phoneNumber}</span>
      {shippingDetails.email && (
        <span className="or-email">{shippingDetails.email}</span>
      )}
    </div>
  </div>
);

export default ShippingAddress;
